import { createAction, handleActions } from 'redux-actions';
import { Api } from "../../api/api";
import { logout, onForbidden } from '../account/login';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess, resetSubmitFormData} from "../common/submitForm";

//- Actions
export const fetchGetBusinessAmbassadorsFailed = createAction('FETCH_GET_BUSINESS_AMBASSADORS_FAILED');
export const fetchGetBusinessAmbassadorsSuccess = createAction('FETCH_GET_BUSINESS_AMBASSADORS_SUCCESS');
export const fetchGetBusinessAmbassadors = createAction(
    'FETCH_GET_BUSINESS_AMBASSADORS',
    () => Api.getBusinessAmbassadors(),
    () => ({
        apiCall: true,
        onSuccess: fetchGetBusinessAmbassadorsSuccess,
        onFail: fetchGetBusinessAmbassadorsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onCreateBusinessAmbassador = (data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchCreateBusinessAmbassador(data));
};

export const fetchCreateBusinessAmbassador = createAction(
    'FETCH_ADD_BUSINESS_AMBASSADORS',
    (data) => Api.addBusinessAmbassador(data),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);


export const onRemoveBusinessAmbassador = (id) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(fetchRemoveBusinessAmbassador(id));
};

export const fetchRemoveBusinessAmbassadorSuccess = () => (dispatch) => {
    dispatch(resetSubmitFormData());
    dispatch(fetchGetBusinessAmbassadors());
};

export const fetchRemoveBusinessAmbassador = createAction(
    'FETCH_REMOVE_ASSISTANT',
    (id) => Api.removeBusinessAmbassador(id),
    () => ({
        apiCall: true,
        onSuccess: fetchRemoveBusinessAmbassadorSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);


//- State
const initialState = {
    fetching: false,
    data: null,
    error: null
};

//- Reducers
export default handleActions({
    FETCH_GET_BUSINESS_AMBASSADORS: (state) => {
        return { ...state, error: null, fetching: true };
    },
    FETCH_GET_BUSINESS_AMBASSADORS_FAILED: (state, action) => {
        return { ...state, data: null, error: action.payload, fetching: false };
    },
    FETCH_GET_BUSINESS_AMBASSADORS_SUCCESS: (state, action) => {
        return { ...state, data: action.payload, error: null, fetching: false };
    }
}, initialState);

//- Selectors
export const getBusinessAmbassadors = state => state.businessAmbassadors;

export const loadingBusinessAmbassadors = state => getBusinessAmbassadors(state).fetching;

export const getBusinessAmbassadorsData = state => getBusinessAmbassadors(state).data;


// WEBPACK FOOTER //
// ./src/reducers/businessAmbassador/businessAmbassadors.js